import FasterEvent from '../fasterEvent'

export default new FasterEvent(
  { id: 'video_crash', revision: 0 },
  (eventBuilder, parameters) => {
    return eventBuilder
      .dimension('videoId', parameters.videoId.toString())
      .dimension('stackTrace', parameters.stackTrace)
      .build()
  }
)
